import { useEffect, useState } from "react";
import { Type } from "lucide-react";
import { useLang } from "@/lib/i18n";

const KEY = "article_font_size";
export const FONT_SCALE = { normal: 1, medium: 1.15, large: 1.3 };   // "normal" == current size

export function readFontSize() {
    try { const v = localStorage.getItem(KEY); return FONT_SCALE[v] ? v : "normal"; } catch { return "normal"; }
}

export function useFontSize() {
    const [size, setSize] = useState(readFontSize);
    const set = (v) => { setSize(v); try { localStorage.setItem(KEY, v); } catch { /* preference simply won't persist */ } };
    useEffect(() => { setSize(readFontSize()); }, []);
    return [size, set];
}

/** «حجم الخط»: عادي / متوسط / كبير — applies to the story text only, remembered locally. */
export default function FontSizeControl({ size, onChange, style }) {
    const { t } = useLang();
    return (
        <div style={style} className="mt-5 flex flex-wrap items-center gap-2 text-xs text-gray-600 dark:text-gray-300" role="group" aria-label={t("fontSize")} data-testid="font-size-control">
            <span className="inline-flex items-center gap-1 font-bold"><Type className="w-4 h-4" aria-hidden="true" /> {t("fontSize")}:</span>
            <div className="inline-flex rounded-sm border border-gray-300 dark:border-gray-600 overflow-hidden">
                {["normal", "medium", "large"].map((k) => (
                    <button key={k} type="button" onClick={() => onChange(k)} aria-pressed={size === k} data-testid={`font-size-${k}`}
                        className={`px-3 min-h-[36px] font-bold transition-colors ${size === k ? "bg-brand-red text-white" : "bg-transparent text-brand-black dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800"}`}>
                        {t(`font_${k}`)}
                    </button>
                ))}
            </div>
        </div>
    );
}
